var _CARD_CONTENT_MAP;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import GridEventCardContent from './GridEventCardContent';
import ListEventCardContent from './ListEventCardContent';
import { LIST_TYPE, GRID_TYPE, STANDARD_STYLE, IMAGE_STYLE_FLUID, TYPES_PROP_TYPE, EVENT_CARD_PROPTYPES, STYLES_PROP_TYPE, IMAGE_STYLES_PROP_TYPE } from './constants';
var CARD_CONTENT_MAP = (_CARD_CONTENT_MAP = {}, _defineProperty(_CARD_CONTENT_MAP, LIST_TYPE, ListEventCardContent), _defineProperty(_CARD_CONTENT_MAP, GRID_TYPE, GridEventCardContent), _CARD_CONTENT_MAP);

var EventCardContent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(EventCardContent, _PureComponent);

  function EventCardContent(props) {
    var _this;

    _classCallCheck(this, EventCardContent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EventCardContent).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_handleOnFocus", function () {
      var onFocus = _this.props.onFocus;

      _this.setState({
        focused: true
      });

      if (onFocus) {
        onFocus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleOnBlur", function () {
      var onBlur = _this.props.onBlur;

      _this.setState({
        focused: false
      });

      if (onBlur) {
        onBlur();
      }
    });

    _this.state = {
      focused: props.focused
    };
    return _this;
  }

  _createClass(EventCardContent, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var focused = _ref.focused;
      this.setState({
        focused: focused
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          eventCardContentProps = _objectWithoutProperties(_this$props, ["type"]);

      var focused = this.state.focused;
      var DynamicCardContent = CARD_CONTENT_MAP[type];
      return React.createElement(DynamicCardContent, _extends({}, eventCardContentProps, {
        onFocus: this._handleOnFocus,
        onBlur: this._handleOnBlur,
        focused: focused
      }));
    }
  }]);

  return EventCardContent;
}(PureComponent);

_defineProperty(EventCardContent, "propTypes", _objectSpread({}, EVENT_CARD_PROPTYPES, {
  /**
   * The base type of card, dictates layout and content display
  */
  type: TYPES_PROP_TYPE,
  style: STYLES_PROP_TYPE,
  imageStyle: IMAGE_STYLES_PROP_TYPE
}));

_defineProperty(EventCardContent, "defaultProps", {
  type: GRID_TYPE,
  style: STANDARD_STYLE,
  imageStyle: IMAGE_STYLE_FLUID
});

export { EventCardContent as default };